import { Box, Container, Divider, Fade, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { COLORS } from '../Constants/styles';
import { ContactForm } from '../Feature/Contact/ContactForm';
import JoinCommunity from '../Feature/Home/JoinCommunity';
import BannerSection from '../Feature/Common/BannerSection';
import { Contact_IMG } from '../Constants/ImageConstants';

const contactBanner = {
  title: 'Contact Us',
  description: 'Get In Touch',
  image: Contact_IMG.contactBanner,
};

const Contact = () => {
  return (
    <>
      <BannerSection data={contactBanner} />

      <Box sx={{ py: 6, backgroundColor: COLORS.greyBG, color: COLORS.pureBlack }}>
        <Container maxWidth="md">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="h4" sx={{ textAlign: 'center', mb: 2 }}>
              Contacts
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.05 }}
          >
            <Typography
              variant="h2"
              sx={{ mt: 5, mb: 2, color: COLORS.pureBlack, textAlign: 'center' }}
            >
              Request More Information
            </Typography>
          </motion.div>

          <Fade in timeout={1000}>
            <Box sx={{ py: 6, display: 'flex', justifyContent: 'center' }}>
              <Container maxWidth="md" sx={{ textAlign: 'center' }}>
                <Typography variant="body2" sx={{ mb: 2, color: COLORS.accentBlackTransparent }}>
                  We appreciate your interest in Grassroots Sports Education & Services.
                  Whether you're a school, parent, coach, or organization   fill in your details below
                  and one of our team members will be in touch within 24–48 hours to help with your query.
                </Typography>
                <Typography variant="body2">
                  <strong>Note:</strong> Have a question? Need a demo? Want to join hands in building a
                  stronger grassroots sports ecosystem? We're here to listen, guide, and support you.
                </Typography>
              </Container>
            </Box>
          </Fade>

          <ContactForm />
        </Container>
        <Divider sx={{ my: 4 }} />
      </Box>

      <JoinCommunity />
    </>
  );
};

export default Contact;
